import { z } from 'zod';
export const ChunkSearchSchema = z.object({
  pageIndex: z.number().default(0),
  pageSize: z.number().default(100)
});